class SildeoutMenu {

    constructor(contentContainer, slideoutMenuContainer) {

        this.startX = null;
        this.startY = null;
        this.startWidth = null;
        this.isSlideStart = false;
        this.isScrolling = false;
        this.width = 0;
        this.contentContainer = contentContainer;
        this.slideoutMenuContainer = slideoutMenuContainer;

        this.handleOnTouchStart = this.handleOnTouchStart.bind(this);
        this.handleOnTouchMove = this.handleOnTouchMove.bind(this);
        this.handleOnTouchEnd = this.handleOnTouchEnd.bind(this);
        this.initSlideoutMenu = this.initSlideoutMenu.bind(this);
    }

    //get the max width of the slideout menu which is 80vw
    getMaxWidth() {
        return $(window).width()*80/100;
    }

    //toggle button on the header menu
    toggleSlideoutMenu(e) {
        e.stopPropagation();
        const body = $('body');
        body.hasClass('slideout') ? body.removeClass('slideout') : body.addClass('slideout');
    }

    //toggle sub item in the menu item in the sub menu
    toggleMenuItem(e) {
        e.stopPropagation();
        const li = $(e.target).closest('li');
        li.hasClass('active') ? li.removeClass('active') : li.addClass('active');
    }

    //click event handler of content-container
    contentContainerOnClick(e) {
        //e.stopPropagation();
        $('body').removeClass('slideout');
    }


    //---------------------------------------handle touch event--------------------------------------
    handleOnTouchStart(e) {
        const maxWidth = this.getMaxWidth();

        this.width = $('body').hasClass('slideout') ? maxWidth : 0;
        this.startX = e.targetTouches[0].pageX;
        this.startY = e.targetTouches[0].pageY;
        this.startWidth = e.targetTouches[0].pageX + this.width;
    }

    handleOnTouchMove(e) {
        if($(e.target).closest('.noUi-target').length > 0 || this.isScrolling) {
            return;
        }

        //only start slide when user slide more than 30px
        if(Math.abs(e.targetTouches[0].pageX - this.startX) < 30 && !this.isSlideStart) {
            return;
        }

        //if touch position Y move more than 30, consider as scrolling vertically and disable slideout menu movemnet.
        if(Math.abs(e.targetTouches[0].pageY - this.startY) > 30 && !this.isSlideStart) {
            this.isScrolling = true;
            return;
        }

        if(this.startX === null) {
            this.startX = e.targetTouches[0].pageX;
            this.startWidth = e.targetTouches[0].pageX + this.width;
            return;
        }

        this.isSlideStart = true;
        this.width = this.startWidth - e.targetTouches[0].pageX;

        //limit the max and min of margin left
        const maxWidth = this.getMaxWidth();
        if(this.width > maxWidth ) this.width = maxWidth;
        if(this.width < 0) this.width = 0;

        this.contentContainer.css({
            'margin-left': -this.width+'px',
            'transition': 'unset'
        });
        this.slideoutMenuContainer.css({
            'width': this.width+'px',
            'transition': 'unset'
        });
    }

    handleOnTouchEnd(e) {
        //if the touch point is the same for both start and end
        //consider as click event
        if(this.startX !== e.changedTouches[0].pageX) {
            this.contentContainer.removeAttr('style');
            this.slideoutMenuContainer.removeAttr('style');

            const maxWidth = this.getMaxWidth();
            const body = $('body');
            if (body.hasClass('slideout') && this.width < maxWidth * 80 / 100) {
                body.removeClass('slideout');
            } else if (this.width > maxWidth * 20 / 100) {
                body.addClass('slideout');
            }
        }

        this.startX = null;
        this.startY = null;
        this.startWidth = null;
        this.isSlideStart = false;
        this.isScrolling = false;
    }

    //--------------------------------------------init function----------------------------------------
    initSlideoutMenu() {

        $('#header .menu-toggle').on('click', this.toggleSlideoutMenu);
        $('#slideout-menu li').on('click', this.toggleMenuItem);
        this.contentContainer.on('click', this.contentContainerOnClick);


        $('#body-container')
            .on('touchstart', this.handleOnTouchStart)
            .on('touchmove', this.handleOnTouchMove)
            .on('touchend', this.handleOnTouchEnd)
            ;
    }

}

export default SildeoutMenu;